// @flow

import { equals, toLower } from 'ramda'

export const isEqualLanguages = (firstKey: string = '', secondKey: string = '') =>
  equals(toLower(firstKey), toLower(secondKey))
